import { c as _c } from "react/compiler-runtime";
import { SubmitRequestFormSkeleton } from './submit-request-form/submit-request-form-skeleton';
import { SummaryCardSkeleton } from './summary-card/summary-card-skeleton';
function SummaryStepSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SummaryCardSkeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-6 flex flex-col-reverse gap-6 lg:grid lg:grid-cols-[3fr_2fr] lg:items-start">{t0}<div className="lg:sticky lg:top-28"><SubmitRequestFormSkeleton /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { SummaryStepSkeleton };